import { createContext, useContext, useState } from "react";

type AuthContext = {
  token: string | null
  setToken: (token: string | null) => void
}

// Esto es como una variable global, todavia sin nada
const AuthContext = createContext<AuthContext | null>(null)

// El provider, quien llena la "variable" global
export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'))

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
